module.exports = __webpack_public_path__ + "img/small_bg20201125.99d07426.png";